import {IProductTourStep} from '@toolify/client/src/modules/productTour/types/IProductTourStep'
import {ProductTourAnchorType} from '@toolify/client/src/modules/productTour/enum/ProductTourAnchorType'
import {
  getProductTourAnchorSelector,
} from '@toolify/client/src/modules/productTour/functions/getProductTourAnchorSelector'

function resolveVisibleElement(anchor: ProductTourAnchorType): HTMLElement | null {
  const element = document.querySelector<HTMLElement>(getProductTourAnchorSelector(anchor))
  if (!element) {
    return null
  }
  // display: none (own or an ancestor's) yields offsetParent === null;
  // position: fixed elements legitimately have no offsetParent
  if (element.offsetParent === null && getComputedStyle(element).position !== 'fixed') {
    return null
  }
  const rect = element.getBoundingClientRect()
  if (rect.width === 0 || rect.height === 0) {
    return null
  }
  return element
}

// Both the store's step availability and the overlay's spotlight anchor resolve
// through here — presence in the DOM is not enough, since toolbar items are hidden
// by CSS on mobile (not v-if), and an invisible anchor would otherwise produce a
// zero-size spotlight in the viewport corner instead of skipping the step.
export function resolveProductTourStepAnchor(step: IProductTourStep): HTMLElement | null {
  if (step.anchor === null) {
    return null
  }
  return resolveVisibleElement(step.anchor)
    ?? (step.fallbackAnchor ? resolveVisibleElement(step.fallbackAnchor) : null)
}
